"use strict";

($dt => {
	
	const controller = {
		
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			$dt.Grid.CreateGrid(container.querySelector('.grid'));	
		}
		
	};

	$dt.blocks['exhibit-grid'] = controller;
	
})(window.d3_wp_themejs);
